import { STORE_KEY } from '@/helpers/firstDataFetcher';
import * as Sentry from '@sentry/vue';

export function setVitalsLogger() {
  function sendToSentry(event) {
    Sentry.captureEvent({
      message: 'Layout shift',
      level: 'info',
      extra: event,
    });
  }

  // eslint-disable-next-line no-unused-vars
  const handleLayoutShifts = entries => {
    entries.forEach(entry => {
      if (entry.value > 0.05) {
        const details = entry.sources.map(
          s =>
            `"${s.node.offsetParent?.className || s.node.offsetParent?.tagName}">"${
              s.node.className || s.node.tagName
            }"`
        );

        const event = {
          value: +entry.value.toFixed(4),
          store: sessionStorage.getItem(STORE_KEY),
          view: window.location.pathname.replace('/dashboard', ''),
          nodes: details,
        };

        sendToSentry(event);
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.debug('CLS', {
            value: event.value,
            view: event.view,
            nodes: entry.sources.map(e => e.node),
          });
        }
      }
      // }
    });
  };

  const clsObserver = new PerformanceObserver(list => {
    handleLayoutShifts(list.getEntries());
  });

  const lcpObserver = new PerformanceObserver(list => {
    const entries = list.getEntries();
    const lastEntry = entries[entries.length - 1]; // Use the latest LCP candidate

    if (lastEntry.startTime > 2500) {
      Sentry.captureEvent({
        message: 'Large LCP',
        level: 'info',
        extra: lastEntry,
      });

      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.debug('LCP', lastEntry);
      }
    }
  });
  lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
  clsObserver.observe({ type: 'layout-shift', buffered: true });
}
